import React, { useEffect, useState } from 'react';
import { IIncentive } from 'src/types/incentive';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import { IProvider } from 'src/types/provider';
import styles from '../assets/incentive-info.module.scss';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import Loader from 'src/components/Loader';
import classNames from 'classnames';
import { getDataCsv } from '../helpers/getDataCsv';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

export interface StateProps {
    data: Partial<IIncentive> | null;
    dataEntities: {
        type?: string;
        list?: any;
    };
    inProgress: boolean;
    inProgressEntity: boolean;
}
export interface DispatchProps {
    getData: (id: string) => void;
    updateIncentive: ({ status, id, setPopup }: any) => void;
    getIncentivesEntities: (params: { id: string | number; caseEnt: string }) => void;
}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    incentiveId: string;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}
const IncentiveDetail: React.FunctionComponent<Props> = ({
    incentiveId,
    getData,
    data,
    inProgressEntity,
    getIncentivesEntities,
    dataEntities,
    inProgress,
}: Props) => {
    const [dataEnt, setdataEnt] = useState<any>([]);
    useEffect(() => {
        if (incentiveId) {
            getData(`${incentiveId}`);
            getIncentivesEntities({ id: `${incentiveId}`, caseEnt: 'incentive_bonuses' });
        }

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        const dataEnt: any = [...dataEntities.list];

        console.log(dataEnt);

        let totalAll = 0;
        if (dataEnt.length) {
            dataEnt.forEach((itPayl: any) => {
                totalAll += +itPayl.amount;
                itPayl.amount = `$${numberWithCommas(itPayl.amount)}`;
            });
            dataEnt.push({
                total: `$${numberWithCommas(totalAll)}`,
            });
        }
        setdataEnt(dataEnt);

        // eslint-disable-next-line
    }, [dataEntities.list]);

    return (
        <div style={{ padding: '30px 0' }}>
            {inProgress || inProgressEntity || !data ? (
                <Loader />
            ) : (
                <div>
                    <div className={classNames(styles.topPanel, 'topPanel')}>
                        <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                            <div>Period:</div>
                            <div>
                                <span>
                                    {data.periodStart ? changeToZeroMoment(data.periodStart, 'MMM D, YYYY') : ''}
                                </span>
                                <span>
                                    {data.periodEnd ? ` - ${changeToZeroMoment(data.periodEnd, 'MMM D, YYYY')}` : ''}
                                </span>
                            </div>
                        </div>
                        <div className={classNames(styles.boardInfo, 'badge-light mr-4')}>
                            <div>Total:</div>
                            <div>
                                <span>${numberWithCommas(data.total)}</span>
                            </div>
                        </div>
                    </div>
                    <SimpleTable
                        data={dataEnt}
                        columns={[
                            { id: 'bonusCaseNumber', label: 'Case Number', cellStyle: 'normal' },
                            { id: 'bonusInfo', label: 'Client', cellStyle: 'nowrap' },
                            { id: 'bonusDate', label: 'Date', cellStyle: 'nowrap' },
                            { id: 'bonusType', label: 'Type', cellStyle: 'normal' },
                            { id: 'amount', label: 'Total', cellStyle: 'normal' },
                        ]}
                    />
                    <div className={'d-flex justify-content-between'}>
                        <button
                            className={'btn btn-outline-info'}
                            onClick={() => {
                                getDataCsv(dataEnt);
                            }}
                        >
                            Export .csv
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default IncentiveDetail;
